export type TelegramSuccessfulPaymentFields = {
    invoice_payload: string;
    telegram_payment_charge_id: string;
    provider_payment_charge_id?: string;
    total_amount: number;
    currency: string;
    is_recurring?: boolean;
    is_first_recurring?: boolean;
    subscription_expiration_date?: number;
};

export type ApplySuccessfulPaymentVariables = {
    input: {
        paymentId: string;
        telegramPaymentChargeId: string;
        providerPaymentChargeId?: string | null;
        amount: number;
        currency: string;
        isRecurring: boolean;
        isFirstRecurring: boolean;
        subscriptionExpiresAt: number | null;
    };
};

export function buildApplySuccessfulPaymentInput(sp: TelegramSuccessfulPaymentFields): ApplySuccessfulPaymentVariables {
    return {
        input: {
            paymentId: sp.invoice_payload,
            telegramPaymentChargeId: sp.telegram_payment_charge_id,
            providerPaymentChargeId: sp.provider_payment_charge_id,
            amount: sp.total_amount,
            currency: sp.currency,
            isRecurring: sp.is_recurring ?? false,
            isFirstRecurring: sp.is_first_recurring ?? false,
            subscriptionExpiresAt: sp.subscription_expiration_date ?? null,
        },
    };
}

export async function confirmPaymentWebhook(
    reply: (text: string) => Promise<unknown>,
    recordPayment: () => Promise<unknown>,
    messages: { paymentReceived: string; paymentReceivedDelayed: string },
    onError: (message: string, error: unknown) => void,
): Promise<void> {
    try {
        await recordPayment();
        await reply(messages.paymentReceived);
    } catch (error) {
        onError('successful_payment failed', error);
        await reply(messages.paymentReceivedDelayed);
    }
}

export type SubscriptionRenewalRecovery = { paymentId: string; telegramUserId: string };

export async function sendSubscriptionRenewalRecoveries(deps: {
    recoveries: SubscriptionRenewalRecovery[];
    miniAppUrl: string;
    messageFor: (telegramUserId: string) => Promise<{ renewalMissing: string; openPremium: string }>;
    send: (telegramUserId: string, text: string, premiumUrl: string | null, buttonText: string) => Promise<unknown>;
    markSent: (paymentId: string) => Promise<unknown>;
}): Promise<void> {
    const premiumUrl = deps.miniAppUrl ? new URL(deps.miniAppUrl) : null;
    if (premiumUrl?.hostname === 't.me') premiumUrl.searchParams.set('startapp', 'premium');
    else if (premiumUrl) premiumUrl.hash = '/premium';
    await Promise.all(
        deps.recoveries.map(async recovery => {
            try {
                const messages = await deps.messageFor(recovery.telegramUserId);
                await deps.send(recovery.telegramUserId, messages.renewalMissing, premiumUrl?.toString() ?? null, messages.openPremium);
                await deps.markSent(recovery.paymentId);
            } catch (error) {
                console.error('Renewal recovery notification failed', { paymentId: recovery.paymentId, error });
            }
        }),
    );
}
